import { render, staticRenderFns } from "./c-alarm-extra-details-chip.vue?vue&type=template&id=391d1c68&scoped=true&"
import script from "./c-alarm-extra-details-chip.vue?vue&type=script&lang=js&"
export * from "./c-alarm-extra-details-chip.vue?vue&type=script&lang=js&"
import style0 from "./c-alarm-extra-details-chip.vue?vue&type=style&index=0&id=391d1c68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391d1c68",
  null
  
)

export default component.exports